const passengers = {
  passengers: 'Passengers',
  passengerTypes: {
    default: 'Default',
    student: 'Student',
    employee: 'Employee',
    caregiver: 'Caregiver',
  },
  headerButtons: {
    create: {
      createBtn: 'Create',
      employee: 'Employee',
      student: 'Student',
    },

    import: 'Import',
  },

  toast: {
    error: {
      badResponse: '[Passenger] bad server response',
      create: {},
      edit: {},
    },
    success: {
      resetSuccess: 'Reset Password email has been sent successfully.',
      create: {
        default: '[Passenger] Created',
      },
      edit: {
        default: '[Passenger] Updated',
      },
      delete: {
        default: '[Passenger] deleted successfully',
      },
    },
    alreadyExistToast: {
      messages: {
        phone: 'Phone already in use by another passenger',
        email: 'Email already in use by another passenger',
      },
    },
  },

  deleteModal: {
    header: 'Delete Passengers',
    body: 'You are about to delete {{num}} passengers.',
  },

  create: {
    successToast: {
      message: 'Success! Passenger created successfully',
    },
    errorToast: {
      message: 'Error Occurred. Could Not Create Passenger!',
    },
  },

  update: {
    successToast: {
      message: 'Success! Passenger updates successfully',
    },
    errorToast: {
      message: 'Error Occurred. Could Not Update Passenger!',
    },
  },

  edit: {
    tabs: {
      information: 'General Information',
      notes: 'Notes',
      history: 'History',
      bookingHistory: 'Booking History',
    },
    modalRemoveConfirm: {
      header: 'Warning!',
      body: 'Are you sure you want to delete this passenger?',
      modalRemoveConfirmBtnConfirm: 'Delete',
    },
    activeStatus: {
      statusActive: 'Active',
      statusDeactivate: 'Inactive',
    },
    suspend: {
      actionActivate: 'Unsuspend',
      actionDeactivate: 'Suspend',
      suspendModal: {
        popupTitleDeactivation: 'Suspend Passenger',
        popupTitleActive: 'Suspend Reason',
        popupTitleUnsuspend: 'Unsuspend Reason',
        popupSubTitleDeactivation: 'Select the reason for the suspenssion',
        popupActionActive: 'Unsuspend Passenger',
        popupActionDeactivate: 'Suspend Passenger',
      },
    },
  },

  table: {
    filters: {
      facility: 'Facility',
      type: 'Type',
    },
    headers: {
      name: 'Name',
      type: 'Type',
      email: 'Email',
      created: 'Date created',
      id: 'Id',
      profile: 'Profile',
      supplier: 'Supplier',
      phone: 'Phone',
      createdBy: 'Created by',
      baseAddress: 'Home Address',
      alternateAddress: 'Alternate Address',
      occupationAddress: 'Office Address',
    },
    passengersGettExtraHeaders: {
      home: 'Home',
      home2: 'Home2',
      work: 'Work',
      site: 'Site',
    },
    empty: 'Empty',
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  import: {
    title: 'Passengers Upload',
  },

  forms: {
    header: {
      createPassenger: {
        title: 'Create',
      },

      updatePassenger: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      profile: {
        header: 'Profile',
        fields: {
          profile: 'Profile',
        },
      },
      supplier: {
        header: 'Supplier',
        fields: {
          label: 'Preferred Supplier',
        },
      },
      attributes: {
        header: 'Attributes',
        fields: {
          label: 'Attributes',
        },
      },
      paymentTypes: {
        header: 'Payment Types',
        fields: {
          membership: 'Membership',
        },
        actions: {
          save: 'Save',
        },
      },
      details: {
        header: 'Personal Details',
        fields: {
          firstName: 'First Name',
          lastName: 'Last Name',
          email: 'Email',
          phone: 'Phone',
          ada: 'Ada',
          additionalPhone: 'Additional Phone',
          code: 'Code',
        },
      },
      address: {
        header: 'Passenger Address',
        sharedValues: {
          manual: 'Manual address',
        },
        fields: {
          homeAddress: {
            label: 'Home Address',
          },
          homeAddress2: {
            label: 'Home Address 2',
          },
          officeAddress: {
            label: 'Office Address',
          },
          workAddress: {
            label: 'Work Address',
          },
        },
      },
      actions: {
        header: 'Actions',
        buttons: {
          delete: 'Delete',
          resetPassword: 'Reset Password',
        },
      },
      health: {
        header: 'Health Information',
        fields: {
          certificationDate: 'Certification Date',
          expirationDate: 'Expiration Date',
          disabilityAidTools: 'Disability Aid Tools',
        },
      },
      caregiverInfo: {
        header: 'Caregiver Information',
        fields: {
          caregiverFirstName: 'First Name',
          caregiverLastName: 'Last Name',
          caregiverEmail: 'Email',
          caregiverPhone: 'Phone',
        },
      },
      jobClusters: {
        header: 'Reservation Clusters',
        fields: {
          limitedMobility: 'Limited Mobility',
        },
        information: {
          limitedMobility: 'The system will ignore "Maximal Distance" and select the nearest possible pickup/dropoff point to the passenger\'s address',
        }
      },
    },
    jobHistory: {
      header: 'Booking History',
      popupInfo: {
        date: 'Requested Pickup Time: {{time}}',
        header: 'Booking Info',
        from: 'From:',
        to: 'To:',
      },
    },

    validations: {
      firstName: 'First Name is required',
      lastName: 'Last Name is required',
      profiles: 'Profiles is required',
      email: {
        required: 'Email is required',
        email: 'Invalid email address',
      },
      unit: {
        required: 'Site is required',
      },
    },
  },

  statuses: {
    onATrip: 'Passengers on A trip',
    completed: 'Passengers completed trips',
    created: 'Passengers Created (From {{hourFrom}})',
  },

  totalPassengers: 'Total Passengers',
};

export default passengers;
